import "./Worlds.css";
import Background from "./Background";
import Medieval from "../assets/Medieval/village.webp";
import SciFi from "../assets/SciFi/home.webp";
import PostApocalyptic from "../assets/PostApocalyptic/city.webp";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../hooks/useIsMobile";
import { ref, remove } from "firebase/database";
import { useAuthContext } from "../firebase/AuthContext";
import { database } from "../firebase/firebaseConfig";

function Worlds() {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState({});
  const [existingScenario, setExistingScenario] = useState(
    localStorage.getItem("scenario")
  );
  const isMobile = useIsMobile();
  const { user, userLanguage } = useAuthContext();

  const worldsList = [
    { name: "Medieval", image: Medieval },
    { name: "SciFi", image: SciFi, upcoming: true },
    { name: "PostApocalyptic", image: PostApocalyptic, upcoming: true },
  ];

  const texts = {
    en: {
      continueWithStory: "Do you want to continue with your Story?",
      yes: "Yes",
      no: "No",
      upcoming: "upcoming",
    },
    de: {
      continueWithStory: "Möchtest du mit deiner Geschichte fortfahren?",
      yes: "Ja",
      no: "Nein",
      upcoming: "bevorstehend",
    },
  };

  const handleImageLoad = (worldName) => {
    setImageLoaded((prevState) => ({ ...prevState, [worldName]: true }));
  };

  const preloadImages = (src) => {
    const img = new Image();
    img.src = src;
    img.onload = () => handleImageLoad(src);
  };

  const scenarioReset = async () => {
    const userRef = ref(database, `sessions/${user.uid}`);
    remove(userRef);
  };

  useEffect(() => {
    worldsList.forEach((item) => preloadImages(item.image));
  }, [worldsList]);

  useEffect(() => {
    if (!existingScenario) {
      if (localStorage.getItem("scenario")) {
        setExistingScenario(localStorage.getItem("scenario"));
      }
    }
  }, []);

  return (
    <>
      <Background />
      <div className="worlds">
        {existingScenario && (
          <div className="scenario-exists">
            <div className="continue-scenario">
              {texts[userLanguage]["continueWithStory"]}
              <div className="buttons">
                <div
                  onClick={() => {
                    navigate(`/scenario?name=${existingScenario}`);
                  }}
                >
                  {texts[userLanguage]["yes"]}
                </div>
                <div
                  onClick={() => {
                    localStorage.clear();
                    scenarioReset();
                    setExistingScenario(null);
                  }}
                >
                  {texts[userLanguage]["no"]}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="worlds-list">
          {worldsList.map((item, index) =>
            imageLoaded[item.image] ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                key={index}
              >
                {item.upcoming && (
                  <div
                    style={{
                      position: "absolute",
                      fontSize: isMobile ? "30px" : "40px",
                      color: "white",
                      textShadow: "0px 0px 20px purple",
                      zIndex: 1,
                    }}
                  >
                    {texts[userLanguage]["upcoming"]}
                  </div>
                )}
                <img
                  src={item.image}
                  onClick={() => {
                    if (!item.upcoming) navigate(`/scenario?name=${item.name}`);
                  }}
                  className="scenario"
                  style={{ filter: item.upcoming && "brightness(30%)" }}
                ></img>
              </div>
            ) : (
              <div className="loading-image" key={index}>
                <Logo
                  style={{
                    height: "50%",
                    animation: "rotate 2s linear infinite",
                  }}
                ></Logo>
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
}

export default Worlds;
